module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.67 0C2.6.18-.05 2.83 0 5.66v100.7a5.69 5.69 0 0 0 3.31 5.03c2 .93 4.55.74 6.36-.49l75.8-50.37A5.58 5.58 0 0 0 88 56.28v47.33c0 3.63 1.74 4.78 3 5.92.63.57 1.3 1.06 2.13 1.5.82.44 1.64.96 3.66.96h11.75c2.02 0 2.93-.52 3.75-.96a10.3 10.3 0 0 0 2.1-1.5c1.25-1.13 2.94-2.29 2.94-5.92V8.42c0-4.92-4.93-8.4-8.79-8.4H96.8c-4.98 0-8.79 4.98-8.79 8.4v47.3c-.02-.2-.04-.4-.08-.6a5.6 5.6 0 0 0-2.46-3.66L9.67 1.1a6.52 6.52 0 0 0-4-1.08z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./static/images/next.svg
// module id = 73/I
// module chunks = 1